import get from "lodash/get";

export const requestKeyboardLock = async (): Promise<void> => {
  if (!("keyboard" in navigator && "lock" in (navigator as any).keyboard))
    return;

  const keys = [
    "AltLeft",
    "AltRight",
    "Tab",
    "Escape",
    "ContextMenu",
    "MetaLeft",
    "MetaRight",
  ];

  console.log("Requesting keyboard lock");

  try {
    await (navigator as any).keyboard.lock(keys);
    console.log("Keyboard lock!");
  } catch (error) {
    console.error("Keyboard lock failed:", error);
  }
};

export const requestKeyboardUnlock = (): void => {
  if (!get(navigator, "keyboard.unlock")) {
    console.log("Keyboard unlock not supported");
    return;
  }

  (navigator as any).keyboard.unlock();
  (navigator as any).keyboard?.lock?.(["Escape"]);
  console.log("Keyboard lock released");
};

export const requestPointerLock = async ({
  element,
  onSuccess,
  onError,
}: {
  element: Element;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}): Promise<void> => {
  try {
    await element.requestPointerLock();
    console.log("Pointer lock activated");
    onSuccess?.();
  } catch (error) {
    console.error("Failed to lock pointer", error);
    onError?.(error);
  }
};

export const exitPointerLock = (): void => {
  try {
    document.exitPointerLock();
  } catch (error) {
    console.error("Error exiting pointer lock:", error);
  }
};
